import { intlDataServiceUrl } from "../utils/constant";

/** PRD-12 文档中心待配置；国际数据服务见 constant.intlDataServiceUrl */
export const WORKSPACE_URLS = {
  intlDataService: intlDataServiceUrl,
  intlDocCenter: "",
};

export default WORKSPACE_URLS;
